<template>
  <div>
    <vx-card class="w-full">
      <div class="flex justify-between items-center">
        <h4 class="flex items-center">
          <span>{{boardLabel}} 엑셀 업로드</span>
          <span class="flex items-center"><ml-input class="ml-8 mr-2" style="width: 100px" type="number" v-model="header.year"/>년</span>
        </h4>
        <vs-button color="secondary" @click="onClickSave">등록</vs-button>
      </div>

      <!-- 기본정보 -->
      <FieldSelectModule
        title="작성자 정보"
        v-model="form.stdInfo"
        :typeslabel="{
          date: '등록일',
        }"
        :board="board"
        :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
        class="mt-28px"
      />

      <!-- 교육 정보 -->
      <div class="mt-28px">
        <div class="flex justify-between items-center mt-6 mb-4">
          <h5><i class="dot"></i> 교육 정보</h5>
        </div>
        <div class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>파일 업로드</div>
            <div class="flex flex-wrap gap-3">
              <vs-button color="secondary" type="border" :href="excelLink">엑셀 템플릿 다운로드</vs-button>
              <vs-button color="secondary" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
              <input v-show="false" ref="excelInput" type="file" multiple @change="onChangeReadFile" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between items-center mt-6 mb-4">
        <h5><i class="dot"></i> 등록 대상 교육 정보</h5>
        <div>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
        </div>
      </div>

      <div>
        <table class="excel-table">
          <colgroup>
            <col width="60" />
            <col width="60" />
            <col/>
            <col width="260" />
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col width="160" />
          </colgroup>
          <thead>
          <tr>
            <th>
              <vs-checkbox :checked="allCheck" @click.native="onClickAllCheckbox"/>
            </th>
            <th>No.</th>
            <th v-for="head in heads">{{ head === '학교명' ? '학교(기관)명' : head}}</th>
            <th>수정/삭제</th>
          </tr>
          </thead>
          <tbody v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
          <tr>
            <td>
              <vs-checkbox v-model="excel.isChecked" />
            </td>
            <td>{{ excel_i + 1 }}</td>
            <td v-for="head in heads" :key="`${excel_i}_td_${head}`">
              <div v-if="editExcelIndex === excel_i" class="p-1">
                <field-selector v-if="head === '학교명'" v-model="editExcelData.row['fieldId']" class="w-full" @select="onChangeField" />
                <ml-input v-else v-model="editExcelData.row[head]" class="w-full" />
              </div>
              <div v-else>
                <div class="flex items-center justify-center gap-2">
                  <p class="flex">
                    {{ excel.row[head] || "-" }}
                    <svg v-if="excel.err && excel.err[head]" style="margin-left:0.5rem;" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 17C13.9183 17 17.5 13.4183 17.5 9C17.5 4.58172 13.9183 1 9.5 1C5.08172 1 1.5 4.58172 1.5 9C1.5 13.4183 5.08172 17 9.5 17Z" fill="#FFDADA"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3 5.8C10.3 5.35817 9.94178 5 9.49995 5C9.05812 5 8.69995 5.35817 8.69995 5.8V9C8.69995 9.44183 9.05812 9.8 9.49995 9.8C9.94178 9.8 10.3 9.44183 10.3 9V5.8ZM9.49597 11.4C9.05634 11.4 8.69995 11.7582 8.69995 12.2C8.69995 12.6418 9.05634 13 9.49597 13H9.50393C9.94356 13 10.3 12.6418 10.3 12.2C10.3 11.7582 9.94356 11.4 9.50393 11.4H9.49597Z" fill="#EA5455"/>
                    </svg>
                    <svg v-else-if="head === '학교명'" style="margin-left:0.5rem;"  width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 17C13.9183 17 17.5 13.4183 17.5 9C17.5 4.58172 13.9183 1 9.5 1C5.08172 1 1.5 4.58172 1.5 9C1.5 13.4183 5.08172 17 9.5 17Z" fill="#CAF9DF"/>
                      <path d="M14.1436 5.95214C14.0413 5.85511 13.9039 5.80078 13.7607 5.80078C13.6175 5.80078 13.48 5.85511 13.3778 5.95214L8.45419 10.824L6.48471 8.8117C6.43769 8.75101 6.37776 8.7008 6.30895 8.66448C6.24013 8.62817 6.16408 8.60658 6.0859 8.6012C6.00772 8.59582 5.92921 8.60676 5.85578 8.63329C5.78235 8.65982 5.71567 8.70133 5.66024 8.75498C5.60482 8.80863 5.56197 8.87317 5.53456 8.94425C5.50716 9.01533 5.49582 9.09126 5.50137 9.16694C5.50693 9.24262 5.52924 9.31627 5.56675 9.38288C5.60427 9.44949 5.65617 9.50753 5.71888 9.55305L8.1259 11.989C8.1259 12.0949 8.34478 12.2008 8.45419 12.2008C8.53912 12.2008 8.62285 12.1816 8.69881 12.1449C8.77477 12.1081 8.84085 12.0547 8.89181 11.989L14.1436 6.69352C14.2438 6.59453 14.3 6.46144 14.3 6.32283C14.3 6.18422 14.2438 6.05113 14.1436 5.95214Z" fill="#28C76F"/>
                    </svg>
                  </p>
                </div>
                <p v-if="excel.err && excel.err[head]" class="errMsg">{{ excel.err[head] }}</p>
              </div>
            </td>
            <td>
              <div class="flex justify-center gap-3">
                <fragment v-if="editExcelIndex === excel_i">
                  <button @click="onClickFinishExcelData(excel_i)">
                    <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button @click="onClickCancelExcelData(excel_i)">
                    <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                  </button>
                </fragment>
                <fragment v-else>
                  <button @click="onClickEditExcelData(excel_i)">
                    <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                  </button>
                  <button @click="onClickRemoveExcelData(excel_i)">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                  </button>
                </fragment>
              </div>
            </td>
          </tr>
          <tr v-show="excel.open">
            <td colspan="11" class="p-0">
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import tabItems from "@/views/boards/tab/tab-items";

import XLSX from "xlsx";
import config from "/public/config";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  name: "PortExcelUpload",
  components: {
    FieldSelector,
    FieldSelectModule,
    CompanySelector,
  },
  props:{
    isPrint: Boolean,
    board: Object,
    header: Object,
  },
  data() {
    return {
      tabItems,
      form: {
        stdInfo: {},
        연도: new Date().getFullYear(),
      },

      excelData: [],

      editExcelIndex: null,
      editExcelData: null,

      fieldList: [],
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    boardId() {
      return this.$route.params.boardId;
    },
    boardLabel() {
      return this.tabItems[this.boardId].label;
    },
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EC%A0%95%EA%B8%B0%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EA%B5%90%EC%9C%A1_%EC%9D%B4%EC%88%98%EA%B2%B0%EA%B3%BC_%EA%B4%80%EB%A6%AC%EA%B0%90%EB%8F%85%EC%9E%90.xlsx`
    },
    heads () {
      return ["구분", "학교명", "성명", "이수여부", "이수방법", "이수시간", "수료일자", "수료기관", "미이수사유"];
    },
    validation () {
      if (this.excelData.length === 0) {
        return "엑셀 정보가 없습니다"
      } else {
        for (const excel of this.excelData) {
          if (Object.keys(excel.err).length > 0) {
            return "입력된 정보를 확인해주세요"
          }
        }
      }
      return true;
    },
    allCheck() {
      if (this.excelData.length > 0) {
        for (const excel of this.excelData) {
          if (!excel.isChecked) {
            return false;
          }
        }
      }
      return true
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      // 학교(기관명) 체크 및 저장시 학교명 이 아닌 학교Id로 저장하기 위해 학교 리스트를 불러온다.
      let code = 'school'
      const options = {
        page: 1,
        perPage: 1000,
        projectId: this.projectId,
        code,
      }
      await this.$store.dispatch("project/LOAD_FIELD_LIST", options);

      const fieldListInfo = this.$store.state.project.fieldListInfo;
      this.fieldList = fieldListInfo.data;
    },
    findField(fieldId, fieldName) {
      if (this.fieldList.length > 0) {
        for (const field of this.fieldList) {
          if (fieldId && field.id === fieldId) {
            return {
              id: field.id,
              field_name: field.field_name,
              cat3: field.facility_category ? field.facility_category.cat3 : '-',
            };
          } else if (fieldName && field.field_name === fieldName) {
            return {
              id: field.id,
              field_name: field.field_name,
              cat3: field.facility_category ? field.facility_category.cat3 : '-',
            };
          }
        }
      }
      return {
        id: 0,
        field_name: '-',
        cat3: '-',
      };
    },

    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    onChangeReadFile(event) {
      this.readFile(event, (sheetData) => {
        const columns = ["C", "D", "E", "F", "G", "H", "I", "J", "K"];

        let rowIndex = 4;
        let rowData = [];
        do {
          rowData = this.getRowData(sheetData, rowIndex++, columns, "w"); // date 타입처리시 날짜 값이 +1 되는 현상이 있어서 w로 처리
          if (!this.isEmptyRowData(rowData)) {
            const isChecked = false
            const row = { fieldId:0, fieldName:'', fieldCat3: ''}
            const err = {}
            for (let i = 0; i < this.heads.length; i++) {
              row[this.heads[i]] = rowData[i];

              // err 처리
              if (i === 1) {
                const fieldId = this.findField('', rowData[i]).id;
                if (fieldId <= 0) {
                  err[this.heads[i]] = "입력된 데이터가 검색되지 않습니다.";
                }
              }

              // date type 처리
              if (i === 6) {
                row[this.heads[i]] = new Date(rowData[i]).format("yyyy-MM-dd");
              }
            }
            this.excelData.push({ isChecked, row, err })
          }
        } while (!this.isEmptyRowData(rowData));
      });
    },
    // 엑셀데이터 파싱
    async readFile(event, callback) {
      // get File object from input tag
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        // declare FileReader, temp result
        const reader = new FileReader();
        const tmpResult = {};

        // if you use "this", don't use "function(e) {...}"
        reader.onload = async (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);
          // get excel file
          const excelFile = XLSX.read(data, { type: "array", cellDates: true });
          const sheetData = excelFile.Sheets[excelFile.SheetNames[0]];

          if (callback) {
            callback(sheetData)
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },

    getCellData(sheet, cell, key = "v") {
      // sheet[row]가 존재하고, 해당 cell 존재하는지 확인
      // sheet[cell].v : Raw value
      // sheet[cell].w : Formatted value
      // sheet[cell].t : Type
      if (sheet[cell] !== undefined) {
        return sheet[cell][key];
      } else {
        return "";
      }
    },
    getRowData(sheet, row, columns, key = "v") {
      const result = [];
      for (const col in columns) {
        const cell = columns[col] + row;
        if (sheet[cell] !== undefined) {
          result.push(sheet[cell][key]);
        } else {
          result.push("");
        }
      }
      return result;
    },
    isEmptyRowData(row) {
      for (const cell of row) {
        if (cell !== "") {
          return false;
        }
      }
      return true
    },

    inputDetail(data) {
      this.editExcelData.form = data;
    },
    onClickEditExcelData(index) {
      this.editExcelIndex = index;
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));

      const field = this.findField('', this.editExcelData.row["학교명"])
      this.editExcelData.row.fieldId = field.id;
      this.editExcelData.row.fieldName = field.field_name;
      this.editExcelData.row.fieldCat3 = field.cat3;
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
    },
    onClickFinishExcelData(index) {
      const field = this.findField(this.editExcelData.row.fieldId, '')

      this.editExcelData.row["학교명"] = field.field_name;
      if (field.id <= 0) { // undefined 가 나오는 경우를 대비해서 다시 fieldId로 변환 후 검사
        this.editExcelData.err["학교명"] = "입력된 데이터가 검색되지 않습니다.";
      } else {
        delete this.editExcelData.err["학교명"];
      }
      this.$set(this.excelData, index, this.editExcelData);
      this.editExcelIndex = null;
      this.editExcelData = null;
    },
    onClickCancelExcelData(index) {
      this.editExcelIndex = null;
      this.editExcelData = null;
    },
    onClickSave() {
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.$emit("customAlert", "엑셀 정보가 없습니다");
        return;
      }

      if (this.validation !== true) {
        this.$emit("customAlert", this.validation);
        return;
      }

      const posts = this.excelData.map((ed) => {
        const field = this.findField('', ed.row["학교명"])
        ed.row["학교명"] = field.id
        ed.row["학교명_string"] = field.field_name
        ed.row["급별"] = field.cat3
        const option = {
          ...this.form,
          ...ed.row,
          fields: [field.id],
        };
        return option;
      });

      this.$emit("save", {posts, callback: (success, data) => {
          if (success) {
            // 초기화
            this.excelData = [];
            this.editExcelData = [];
            this.editExcelIndex = null;
          }
        }});
    },
    // 정렬 후 기타, 기타 외를 배열의 마지막으로 이동하는 함수
    setCatOther(list) {
      list.sort();

      const etcIndex = list.indexOf("기타");
      if (etcIndex > -1) {
        list.splice(etcIndex, 1);
        list.push("기타");
      }
      const etcOutIndex = list.indexOf("기타 외");
      if (etcOutIndex > -1) {
        list.splice(etcOutIndex, 1);
        list.push("기타 외");
      }

      return list;
    },
    // 일괄 체크
    onClickAllCheckbox() {
      if (this.allCheck) {
        if (this.excelData.length > 0) {
          for (const excel of this.excelData) {
            excel.isChecked = false
          }
        }
      } else {
        if (this.excelData.length > 0) {
          for (const excel of this.excelData) {
            excel.isChecked = true
          }
        }
      }
    },
    onChangeField (field) {
      this.editExcelData.row['fieldId'] = field.id
      this.editExcelData.row['fieldName'] = field.field_name
      this.editExcelData.row['fieldCat3'] = field.facility_category ? field.facility_category.cat3 : '-'
    },
    deleteRow() {
      if (this.excelData.length > 0) {
        this.excelData = this.excelData.filter((excel) => !excel.isChecked);
      }
    }
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  thead {
    th {
      text-align: center;
    }
  }

  th,
  td {
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  .sub-table {
    th {
      background: #7e72f20d;
      border-top: 0;
      padding: 16px 10px;
    }
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}

.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}
</style>
